import { memo } from 'react';

import { useAppSelector } from '@/app/store/hooks';
import {
  BalloonStatus,
  selectBalloonBetAmount,
  selectBalloonCurrency,
  selectBalloonMultiplier,
  selectBalloonStatus,
} from '@/entities/balloon';
import { type CurrencyCode,formatCurrencyValue } from '@/shared/lib/currency';

interface BalloonStatRowProps {
  fallbackBet: number;
  fallbackCurrency: CurrencyCode;
}

export const BalloonStatRow = memo(({ fallbackBet, fallbackCurrency }: BalloonStatRowProps) => {
  const status = useAppSelector(selectBalloonStatus);
  const multiplier = useAppSelector(selectBalloonMultiplier);
  const activeBet = useAppSelector(selectBalloonBetAmount);
  const activeCurrency = useAppSelector(selectBalloonCurrency);

  const isHeating = status === BalloonStatus.HEATING;
  const isPaused = status === BalloonStatus.PAUSED;
  const displayBet = activeBet ?? fallbackBet;
  const currency = ((activeCurrency ?? fallbackCurrency) as CurrencyCode) ?? 'TON';

  return (
    <div className="balloon-panel__stat-row">
      <div className="balloon-panel__stat">
        <span className="balloon-panel__stat-label">Bet</span>
        <span className="balloon-panel__stat-value">{formatCurrencyValue(displayBet, currency)}</span>
      </div>
      <div className="balloon-panel__stat">
        <span className="balloon-panel__stat-label">Multiplier</span>
        <span
          className={[
            'balloon-panel__stat-value',
            isHeating && 'balloon-panel__stat-value--active',
            isPaused && 'balloon-panel__stat-value--paused',
          ]
            .filter(Boolean)
            .join(' ')}>
          {multiplier.toFixed(2)}×
        </span>
      </div>
      <div className="balloon-panel__stat">
        <span className="balloon-panel__stat-label">Potential</span>
        <span className="balloon-panel__stat-value">
          {formatCurrencyValue(displayBet * multiplier, currency)}
        </span>
      </div>
    </div>
  );
});
